import React, { useContext, useEffect } from "react";
import { DataContext } from "./DataContext"; //import DataContext (<DataProvider> in index.js)
const EventSchema = () => {
    const { events } = useContext(DataContext);
    useEffect(() => {
        if (!events) return;
        const videoSchema = {
            ...(events?.length > 0 && {
                "events": events?.map((event, index) => ({
                    "@type": "MusicEvent",
                    "name": event.name,
                    "startDate": event.start_date,
                    "endDate": event.endDate, // Ensure correct key case
                    "url": `https://www.dysband.com/eventpage/${event.id}`,
                    "location": {
                        "@type": "Place",
                        "name": event.name || `Event Venue ${index + 1}`,
                        "address": event.place || "Unknown Street"
                        //{
                        //    "@type": "PostalAddress",
                        //    "streetAddress": event.place || "Unknown Street"
                        //}
                    },
                    "performer": {
                        "@type": "MusicGroup",
                        "name": "Dirty Yachtin Scoundrels"
                    }
                    //,
                    //"offers": event.ticket_price && event.ticket_uri ? {
                    //    "@type": "Offer",
                    //    "price": parseFloat(event.ticket_price), // Ensure price is a number
                    //    "priceCurrency": "USD",
                    //    "url": event.ticket_uri,
                    //    "availability": "https://schema.org/InStock"
                    //} : undefined
                }))
            })
        }
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.textContent = JSON.stringify(videoSchema, null, 2);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default EventSchema;